Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-quantity-selector', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-quantity-selector', $context);

        if ($control.length < 1)
            return;

        var intRegex = /^[0-9]*$/;
        var decRegex = /^[0-9]*(\.[0-9]+)$/;

        var $field = $('.js-selector', $control);

        var $first = $control.first();
        var unitType = $first.data('unit-type') ? $first.data('unit-type') : 'int';
        var quanta = $first.data('quanta') ? parseFloat($first.data('quanta')) : 1;
        var minQty = $first.data('min') === '' ? ($first.data('quanta') ? parseFloat($first.data('quanta')) : 1) : parseFloat($first.data('min'));
        var maxQty = $first.data('max') === '' ? null : parseFloat($first.data('max'));

        //Icremental Selector
        if ($field.hasClass('free-text') || ($field.hasClass('incremental') && !$field.attr('readonly'))) {

            $field.on('keyup change', function (e) {
                var $this = $(this);
                var qty = $this.val();

                if (qty >= minQty && (qty <= maxQty || !maxQty)) {
                    if (unitType === 'int') {
                        qty = parseInt(qty);
                        if (quanta) {
                            if (qty >= quanta) {
                                qty = Math.round(qty / quanta) * quanta;
                            } else {
                                qty = quanta;
                            }
                        }
                        $field.val(qty);
                    }
                    else if (unitType === 'decimal') {
                        qty = parseFloat(qty);
                        if (quanta) {
                            if (qty >= quanta) {
                                qty = Math.round(qty / quanta) * quanta;
                            } else {
                                qty = quanta;
                            }
                        }
                        $field.val(qty.toFixed(2));
                    }
                } else {
                    if (maxQty && $this.val() > maxQty) {
                        qty = maxQty;
                        $field.val(qty);
                    } else {                      
                        if (minQty) {
                            qty = minQty;
                            if (e.type === "change") $field.val(qty);
                        } else if (quanta) {
                            qty = quanta;
                            if (e.type === "change") $field.val(qty);
                        } else {
                            qty = 1;
                            if (e.type === "change") $field.val(1);
                        }                      
                    }
                }

                Vendd.MessageBus.publishAsync($control, new Vendd.Product.Messages.SetQuantity(qty));
            });

        }

        //Icremental Selector
        if ($field.hasClass('incremental')) {

            $control.on('click', '.js-minus', function (event) {

                if ($control.hasClass('disabled'))
                    return;

                var $this = $(this), qty;

                if (intRegex.test(quanta)) {
                    qty = parseInt($field.val()) - parseInt(quanta);
                } else if (decRegex.test(quanta)) {
                    qty = parseFloat($field.val()) - parseFloat(quanta);
                    qty = qty.toFixed(2);
                }

                if (qty >= minQty) {
                    $field.val(qty);
                    Vendd.MessageBus.publishAsync($control, new Vendd.Product.Messages.SetQuantity(qty));
                }
            });

            $control.on('click', '.js-plus', function (event) {

                if ($control.hasClass('disabled'))
                    return;

                var $this = $(this), qty;

                if (intRegex.test(quanta)) {
                    qty = parseInt($field.val()) + parseInt(quanta);
                } else if (decRegex.test(quanta)) {
                    qty = parseFloat($field.val()) + parseFloat(quanta);
                    qty = qty.toFixed(2);
                }

                if ((maxQty && qty <= maxQty) || !maxQty) {
                    $field.val(qty);
                    Vendd.MessageBus.publishAsync($control, new Vendd.Product.Messages.SetQuantity(qty));
                }

            });
        }

        //Dropdown Selector
        if ($field.hasClass('dropdown')) {
            if (!isTouch()) {
                $field.sSelect().change(function () {

                    var $this = $(this);
                    var qty = $this.val();
                    $field.val(qty);

                    Vendd.MessageBus.publishAsync($control, new Vendd.Product.Messages.SetQuantity(qty));
                });
            } else {
                $field.on('change', function () {

                    var $this = $(this);
                    var qty = $this.val();
                    $field.val(qty);

                    Vendd.MessageBus.publishAsync($control, new Vendd.Product.Messages.SetQuantity(qty));
                });
            }
        }

        var skuQuanta = ($control.data('quanta') ? stringToNumber($control.data('quanta')) : null) || 0;
        skuQuanta = Vendd.Helpers.isInteger(parseFloat(skuQuanta)) ? parseInt(skuQuanta) : parseFloat(skuQuanta);
        Vendd.MessageBus.publishAsync($control, new Vendd.Product.Messages.SetQuanta(skuQuanta));

    });

});